<template>
  <ChannelSelect
    v-if="channel.personId"
    class="channel-member-dropdown"
    disable-typing
    :new-label="labelNew"
    :person-id="channel.personId"
    :value="channel"
    :placeholder="placeholder"
    show-chat
    show-archived
    :disable-create="!enableCreateChannel"
    @input="onSelectChannel"
    @toggle="onDropdownClick"
  />
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import { ChannelSelect } from '@/components/shared/organisms'
import { CHAT_TITLE } from '@/models/channels'
import Logger, { EventModel, EventName } from '@/wrappers/logger'

export default {
  components: {
    ChannelSelect
  },
  props: {
    channel: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('member', ['getMemberById']),
    ...mapGetters('pillars/channel', ['newChannel']),
    ...mapState('pillars', ['personId']),
    ...mapState('permissions', {
      channelsPermission: state => state.channels
    }),
    memberName() {
      const member = this.getMemberById({
        channelPersonId: this.channel.channelPersonId
      })
      return member?.nickName || member?.firstName || 'membro'
    },
    labelNew() {
      return `Criar novo canal com ${this.memberName}`
    },
    placeholder() {
      return this.channel?.name || CHAT_TITLE
    },
    enableCreateChannel() {
      return this.channelsPermission?.general.create
    }
  },
  methods: {
    onDropdownClick(isOpen) {
      const action = isOpen ? 'open' : 'close'
      Logger.addLog(EventName.USER_INTERACTION_MENU, {
        model: EventModel.CHANNELS,
        data: {
          context: 'channel_dropdown',
          action
        }
      })
    },
    onSelectChannel(channel) {
      if (this.$route.query.channelId === channel.id) {
        return
      }
      if (!channel.id) {
        this.$store.commit('pillars/channel/setControlChannel', this.newChannel)
        this.$store.commit('ui/channel/toggleChannelControl')

        Logger.addLog(EventName.USER_INTERACTION_MENU, {
          model: EventModel.CHANNELS,
          data: {
            context: 'channel_dropdown',
            action: 'create_channel'
          }
        })

        return
      }

      Logger.addLog(EventName.USER_INTERACTION_MENU, {
        model: EventModel.CHANNELS,
        modelId: channel.id,
        data: {
          context: 'go_to_channel',
          channelKind: channel.kind,
          channelCategory: channel.category,
          channelSubCategory: channel.subCategory,
          channelSubCategoryClassifier: channel.subCategoryClassifier,
          channelStatus: channel.status,
          isChannelStaff: channel.staffIds?.includes(this.user.id)
        }
      })

      this.$router.push({
        params: {
          pathMatch: `/member/${channel.personId || this.personId}/pillars`
        },
        query: {
          ...this.$route.query,
          channelId: channel.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-member-dropdown {
  width: 50%;
  :deep(input[readonly]) {
    font-weight: var(--gl-font-weight-semibold);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
